import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: var(--color-text-light);
  font-weight: 500;
  margin-bottom: 40px;
  transition: color 0.2s;

  &:hover {
    color: var(--color-primary-blue);
  }
`;

const BackButton = () => {
  return (
    <StyledLink to="/activities">
      <ArrowBack fontSize="small" />
      <span>Back to Events</span>
    </StyledLink>
  );
};

export default BackButton;